import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { latestSsePayload, getEntryRosterSelector } from '../../reducers/reigniteSseSlice'
import ReigniteServerSentEvents from '../../components/shared/ReigniteServerSentEvents'
import { ReigniteSsePayload } from '../../utils/types'
import { AzpId } from '../../types.results.reignite'

export function ReigniteEntryRosterSse(props: {
  azp: string
  eventId: string
  entryId: AzpId | undefined
  entryNotFound: boolean
  refetch: () => void
}) {
  const {
    azp,
    eventId,
    entryId,
    entryNotFound,
    refetch,
  } = props

  const path = (
    azp && eventId && entryId
      ? `azp/${azp}/event/${eventId}/entry/${entryId}/roster`
      : ''
  )

  const sseState = useSelector(getEntryRosterSelector(path))
  const dispatch = useDispatch()

  React.useEffect(() => {
    console.debug('sseState', {
      azp,
      eventId,
      entryId,
      sseState,
    })
    if (
      !entryNotFound &&
      sseState?.lastUpdated &&
      sseState.lastPayload?.type === 'roster' &&
      +(entryId || 0) === sseState.lastPayload.payload.entryId
    ) {
      try {
        refetch()
      }
      catch (err) {
        console.warn(err)
      }
    }
  }, [
    azp,
    eventId,
    entryId,
    entryNotFound,
    refetch,
    sseState,
    dispatch
  ])

  const onMessage = React.useCallback(
    (data: ReigniteSsePayload) =>
      dispatch(
        latestSsePayload({
          path,
          ...data
        })
      ),
    [
      dispatch,
      path,
    ]
  )

  return <>
    {
      path &&
        <ReigniteServerSentEvents
          onMessage={onMessage}
          path={path}
        />
    }
  </>
}
